
<template>
      <router-view/>
 </template>


<style>
#app{
 height: 100%;
}

</style>
